<template>
  <div
    class="wrapper row no-margin"
    style="height: 100%;display: flow-root;">

    <header class="row align-items-center no-margin">
      <div class="col">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')">
          <i class="fas fa-times"/>
        </button>
      </div>
    </header>

    <div class="col-12 mt-3 mb-1 status">
      {{ $t('apps.pos.message.queuelist') }} ({{ queues.length }})
    </div>
    <ul class="col-12 no-padding items">
      <li
        v-for="(queue, index) in mapQueues"
        :key="index"
        class="row no-margin item"
        @click="onSelectedQueue(queue.queue_number)"
      >
        <div class="col">
          <span class="mr-1">
            {{ $t('apps.pos.message.queuenumber', {number: queue.queue_number}) }}
          </span>
          <span
            v-if="isRenderTime"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{
              getDiffTime(queue.start_at, {
                hours: $t('message.hours'),
                minutes: $t('message.minutes'),
                seconds: $t('message.seconds')
              })
            }}
          </span>
          <span
            v-if="isRenderTime && queue.expire_time_mins"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{
              $t('apps.pos.message.qrcodetimeleft', { number: queue.expire_time_mins })
            }}
          </span>
          <span
            v-if="queue.table_number"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ $t('message.tablename', { ref_name: refName, number: queue.table_number }) }}
          </span>
          <span
            v-if="queue.orderCount"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ $t('apps.pos.message.orderinqueuecount', { number: queue.orderCount }) }}
          </span>
          <span
            v-if="queue.dining_name"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ getDiningText(queue.dining_name) }}
          </span>
          <span
            v-if="queue.customer_id"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ getCustomerName(queue.customer_id) }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import queueListMixins from '@/mixins/pos/queueList'

export default {
  mixins: [queueListMixins],
}
</script>

<style scoped>
.wrapper ul.items {
  overflow: auto;
}
.wrapper ul.items li.item {
  padding: 10px 15px;
  background: #fff;
  border-bottom: solid 1px #F2F2F2;
  cursor: pointer;
}
.wrapper ul.items li.item .col {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/QueueList.vue